import type { Currency, CurrencyOption } from '@/types/creator';

/**
 * Currency helpers for the creator portal. All money renders in the currency the
 * API returns: campaign amounts in the invite's own currency, wallet totals
 * server-converted into the creator's display currency. There is no client-side
 * FX; formatMoney takes the currency symbol the API supplies.
 */

export const supportedCurrencies: Currency[] = ['GBP', 'USD', 'EUR'];

export const currencyOptions: CurrencyOption[] = [
    { code: 'GBP', label: 'GBP (British pound)', name: 'British pound', symbol: '£' },
    { code: 'USD', label: 'USD (US dollar)', name: 'US dollar', symbol: '$' },
    { code: 'EUR', label: 'EUR (Euro)', name: 'Euro', symbol: '€' },
];

export const formatMoney = (symbol: string, amount: string | number): string =>
    `${symbol}${Number(amount).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
